import { render, staticRenderFns } from "./ServiceResume.vue?vue&type=template&id=28494aea"
import script from "./ServiceResume.vue?vue&type=script&lang=js"
export * from "./ServiceResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports